export default {
  // 首页
  aboutus: "ABOUT US",
  contactus:"CONTACT US",
  downpdf:"DOWNLOAD",
  getData:"ACQUIRING DATA",
  news: "NEWS",
  address:"Room 1012, Tower T1 Building C, Wangjing SOHO, Chaoyang District, Beijing,  China",
  messageBord:"MESSAGE BORD",
  username:"Name",
  phone:"Phone",
  email:"Email",
  message:"Your Message",
  submit:"SUBMIT",
  pleaseLeave:"Please leave your contact information",
  pleaseCorrect:"Please provide the correct email address for us to contact you",
  submitSuccess:"SUBMIT SUCCESSFULLY",
  bottom:"2024 FUTURE CITIZEN BUREAU. All Rights Reserved.",
  newsPrev:"PREVIOUS POST",
  newsNext:"NEXT CHAPTER",
  newsReturnList:"RETURN LIST",
  LearnMore:"LEARN MORE",
  showDetail:"Detail",
  irelandProject:"IRELAND PROJECT",
  vanuatuProject:"VANUATU PROJECT",
  service_content:"SERVICE CONTENT",
  cooperateAdv:"COOPERATIVE ADVANTAGES",
  bahamas:"BAHAMAS",
  slovenia:"SLOVENIA",
  ireland:"IRELAND",
  vanuatu:"VANUATU",
  projectPlan:"PROJECT PLAN",
  projectOverview:"PROJECT OVERVIEW",
  applicant:"APPLICATION REQUIREMENTS",
  moreNews:"MORE NEWS",
};
